import List from "./EntityList";
import SchoolView from "./SchoolView";

const exportObj = {List, SchoolView}

export default exportObj